import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './assets/css/app.css'
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { RecoilRoot } from 'recoil';

const root = ReactDOM.createRoot(
  document.getElementById('main-wrapper') as HTMLElement
);
root.render(
  // <React.StrictMode>
    <RecoilRoot>
    <App />
    </RecoilRoot>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
